import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, MapPin, Building2 } from "lucide-react";
import { fetchFeaturedRealizations, photoUrl } from "../lib/api";
import { categoryLabel } from "../data/realizations";

function Card({ p, i, large }) {
  const cover = p.cover || p.photos_after?.[0] || p.photos_during?.[0] || p.photos_before?.[0];
  return (
    <motion.div
      initial={{ opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.6, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
      className={large ? "sm:col-span-2 sm:row-span-2" : ""}
    >
      <Link
        to={`/realisations/${p.id}`}
        data-testid={`home-realization-${p.id}`}
        className="group relative block h-full min-h-[220px] overflow-hidden rounded-3xl bg-navy shadow-lg"
      >
        {cover ? (
          <img src={photoUrl(cover)} alt={p.title} loading="lazy" className="absolute inset-0 h-full w-full object-cover transition-transform duration-[900ms] group-hover:scale-110" />
        ) : (
          <div className="absolute inset-0 grid place-items-center text-white/20"><Building2 size={40} /></div>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-navy/90 via-navy/30 to-transparent" />
        <div className="absolute left-4 top-4">
          <span className="rounded-full bg-white/90 px-3 py-1 text-[11px] font-semibold text-navy backdrop-blur">{categoryLabel(p.category)}</span>
        </div>
        <div className="absolute inset-x-0 bottom-0 p-5">
          <h3 className={`font-display font-bold text-white ${large ? "text-2xl" : "text-lg"}`}>{p.title}</h3>
          {p.location && <span className="mt-1 inline-flex items-center gap-1 text-sm text-white/75"><MapPin size={13} /> {p.location}</span>}
        </div>
      </Link>
    </motion.div>
  );
}

export const RealizationsShowcase = () => {
  const [list, setList] = useState([]);

  useEffect(() => {
    fetchFeaturedRealizations().then(setList).catch(() => setList([]));
  }, []);

  if (!list || list.length === 0) return null;

  return (
    <section data-testid="home-realizations" className="bg-navy py-20 sm:py-28">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full border border-gold/40 bg-gold/10 px-4 py-1.5 text-sm font-medium text-gold-400">
              <Building2 size={15} /> Nos réalisations
            </span>
            <h2 className="mt-4 max-w-xl font-display text-3xl font-bold leading-tight text-white sm:text-4xl">
              La preuve par le béton.
            </h2>
            <p className="mt-3 max-w-lg text-white/60">
              Quelques-uns de nos plus beaux chantiers. La qualité TIRERA GROUP, visible sur le terrain.
            </p>
          </div>
          <Link
            to="/realisations"
            data-testid="see-all-realizations"
            className="group inline-flex items-center gap-2 rounded-full bg-gold px-6 py-3 text-sm font-bold text-navy transition-colors hover:bg-gold-400"
          >
            Voir toutes nos réalisations
            <ArrowRight size={17} className="transition-transform group-hover:translate-x-1" />
          </Link>
        </div>

        <div className="mt-10 grid auto-rows-[220px] gap-4 sm:grid-cols-3">
          {list.slice(0, 4).map((p, i) => (
            <Card key={p.id} p={p} i={i} large={i === 0} />
          ))}
        </div>
      </div>
    </section>
  );
};
